import {fromJS, Map} from 'immutable';
import alertsActions from '../actions/alerts.actions';
import dieselReducer from 'epic-diesel-common/src/decorators/DieselReducer';

import {
    Alerts as BaseAlerts,
    PayoutAccountStatus,
    TaxAccountStatus,
    OfflinePaymentAccountStatus,
    BOAPaymentAccountStatus
} from '../../shared/types';

export const Alerts = {
    ...BaseAlerts,
    ...PayoutAccountStatus,
    ...TaxAccountStatus,
    ...OfflinePaymentAccountStatus,
    ...BOAPaymentAccountStatus,
    ERROR: 'ERROR',
    ANNOUNCEMENT: 'ANNOUNCEMENT'
};

export type Alerts = typeof Alerts;
export type AlertType = keyof Alerts;

export interface AlertsState {
    alerts: AlertType[];
    loading: boolean;
    lastFetch: number;
}

export const DEFAULT_STATE = fromJS({
    alerts: [],
    loading: false
});

export const alertsReducer = (state: Map<keyof AlertsState, any> = DEFAULT_STATE, action) => {
    let newState = state;
    switch (action.type) {
        case alertsActions.TYPES.GET_ALERTS: {
            return newState.updateIn(['loading'], () => true);
        }
        case alertsActions.TYPES.GET_ALERTS_COMPLETE: {
            const {data} = action.payload;

            if (data) {
                return newState.merge(
                    fromJS({
                        alerts: data,
                        lastFetch: Date.now(),
                        loading: false
                    })
                );
            }

            return newState.updateIn(['loading'], () => false);
        }
        case alertsActions.TYPES.GET_ALERTS_FAILED: {
            return newState.updateIn(['loading'], () => false);
        }

        case alertsActions.TYPES.APPEND_TO_ALERT_LIST: {
            const message = action.payload;
            const {alerts} = state.toJS();
            alerts.push(message);
            return newState.updateIn(['alerts'], () => fromJS(alerts));
        }

        case alertsActions.TYPES.REMOVE_ALERTS_COMPLETE: {
            const removeAlerts = action.payload || [];
            const {alerts = []} = state.toJS();

            if (alerts.length && removeAlerts.length) {
                newState = newState.updateIn(['alerts'], () =>
                    fromJS(alerts.filter(alert => !removeAlerts.includes(alert)))
                );
            }

            return newState;
        }

        default:
            return newState;
    }
};

export default dieselReducer('alerts', alertsReducer);
